<template>
  <div class="saveReport" :class="hasReportData ? 'reSaveReport' : ''">
    <h1>Report Save</h1>
    <div class="info">
      <p class="ellipsis"><a :href="reportDatum.url" target="_blank"
        :title="`${reportDatum.url} : ${$t('common.openNewWindow')}`">{{ reportDatum.url }}</a></p>
      <p>{{ report.runAt | yymmddhhmm }}</p>
      <p class="score">Error <em>{{ report.errorCount }}
        / {{ report.passCount + report.errorCount }}</em></p>
    </div>
    <p v-if="hasReportData" class="message">{{ $t('saveReport.reportDataExist') }}</p>
    <table>
      <colgroup>
        <col width='230' />
        <col width='*' />
      </colgroup>
      <tr>
        <th>{{ $t('saveReport.group') }}</th>
        <template v-if="hasReportData">
          <td colspan="2">
            {{ parentReportData.ReportGroup.name }}
          </td>
        </template>
        <template v-else>
          <td>
            <span class="select">
              <select v-model="model.reportGroupId">
                <option value="">{{ $t('saveReport.newGroup') }}</option>

                <option v-for="(item, index) in reportGroups" :key="index"
                  :value="item.id">{{ item.name }}</option>
              </select>
            </span>
          </td>
          <td>
            <input type="text" name="" :title="$t('saveReport.newGroup')" maxlength="50"
              ref="newGroupName"
              :disabled="!!model.reportGroupId"
              v-model.trim="model.newGroupName" />
            <span class="wrong" v-if="errors.newGroupName">
              * {{ $t(errors.newGroupName) }}
            </span>
          </td>
        </template>
      </tr>
      <tr>
      <th>{{ $t('saveReport.pageName') }}</th>
      <td colspan="2">
        <span v-if="hasReportData">
          {{ parentReportData.title }}
        </span>
        <template v-else>
          <input type="text" name="" :title="$t('saveReport.pageName')"
            v-model.trim="model.title" maxlength="50" />
          <span class="wrong" v-if="errors.title">
            * {{ $t(errors.title) }}
          </span>
        </template>
      </td>
      </tr>
    </table>
    <p class="btns">
      <button type="button" class="btn_2" @click="onSaveClick">{{ $t('common.save') }}</button>
      <button type="button" class="btn_3" @click="onCancelClick">{{ $t('common.cancel') }}</button>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import reportApi from '@/api/report'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'ReportSave',
  mixins: [ajaxHandlerMixin],
  props: ['report', 'parentReportData'],
  data () {
    return {
      errors: {},
      model: {
        tempReportId: null,
        title: null,
        reportGroupId: '',
        newGroupName: null,
        reportDataId: null
      }
    }
  },
  computed: {
    ...mapGetters(['reportGroups']),
    reportDatum () {
      return this.report.ReportDatum
    },
    hasReportData () {
      return !!this.parentReportData
    }
  },
  created () {
    this.model.tempReportId = this.report.id

    if (this.parentReportData) {
      this.model.reportDataId = this.parentReportData.id
      this.model.reportGroupId = this.parentReportData.ReportGroup.id
      this.model.title = this.parentReportData.title
    } else {
      this.fetchReportGroups()
    }
  },
  watch: {
    'model.reportGroupId' (value) {
      if (value) {
        this.model.newGroupName = ''
      } else {
        this.$nextTick().then(() => {
          this.$refs.newGroupName.focus()
        })
      }
    }
  },
  methods: {
    ...mapActions(['fetchReportGroups']),
    onSaveClick () {
      this.errors = {}

      reportApi.addByTempReportId(this.model).then(response => {
        this.$emit('onSaveClick', response.data)
      }).catch(this.handleAjaxError)
    },
    onCancelClick () {
      this.$emit('onCancelClick')
    }
  }
}
</script>

<style scoped>
.saveReport {position:fixed; top:200px; left:25%; right:25%; min-width:300px; padding:40px; box-shadow: 1px 1px 10px #333; background : #fff; border-radius:3px; }
.saveReport h1 {line-height:40px; color:#294f75; font-size:16px;}
.saveReport .info {position:relative; padding:0 20px 0 140px; background:#efefef; }
.saveReport .info * {font-size:12px;}
.saveReport .info p {line-height:30px;}
.saveReport .info p:first-child {border-bottom:1px solid #ddd; }
.saveReport .info p:first-child a:hover, .saveReport .info p:first-child a:focus {color:#4d627b; border-bottom:1px solid #4d627b;}
.saveReport .info .score {position:absolute; left:0; top:10px; width:120px; line-height:1;  text-align:center;}
.saveReport .info .score  em {display:block; font-size:25px; color:#4d627b;}
.saveReport .message { padding-top: 20px; text-align: center; }

.saveReport table {margin-top:20px;}
.saveReport table * {font-size:13px;}
.saveReport table th {text-align:right; vertical-align:top; line-height:40px; padding-right:20px;  }
.saveReport table td {position:relative; padding:0 10px 35px 0; line-height:40px;}
.reSaveReport table th,
.reSaveReport table td { padding-bottom: 10px; }
.saveReport table td .select {width:100%;}
.saveReport table td .wrong {position:absolute; left:0; bottom:15px; font-size:11px; color:#ff0000; }

.saveReport .btns {padding-top:10px; text-align:center;}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportSave.vue